<div id="toolbar" class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
  <div class="navbar-header">
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item mr-auto">
        <a class="navbar-brand" [routerLink]="['/']">
          <img src="assets/images/logo.svg" width="160" alt="vittoria">
        </a>
      </li>
    </ul>
  </div>
  <div class="shadow-bottom"></div>
  <div class="main-menu-content">
    <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <li class="nav-item {{menuToolbar['adm']['index']}}">
        <a class="d-flex align-items-center" [routerLink]="['/']" data-toggle="tooltip"
           data-placement="auto" title="Inicio">
          <i data-feather="home"></i>
          <span class="menu-title text-truncate" title="Inicio" data-i18n="Dashboards">Inicio</span>
        </a>
      </li>
      <li class="navigation-header">Administración</li>
      <li class="nav-item {{menuToolbar['adm']['user']}}" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" [routerLink]="['/admin/user']" data-toggle="tooltip"
           data-placement="auto" title="Creación de los usuario del sistema">
          <i data-feather="user"></i>
          <span class="menu-title text-truncate" data-i18n="User">Usuarios</span>
        </a>
      </li>
      <li class="nav-item {{menuToolbar['adm']['roles']}}" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" [routerLink]="['/admin/roles']" data-toggle="tooltip"
           data-placement="auto" title="Creación de los roles del sistema">
          <i data-feather="check-square"></i>
          <span class="menu-title text-truncate" data-i18n="Todo">Rol de usuarios</span></a>
      </li>
      <li class="nav-item {{menuToolbar['adm']['param']}}" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" [routerLink]="['/admin/param']" data-toggle="tooltip"
           data-placement="auto" title="Parametrizaciones de administración">
          <i data-feather="circle"></i>
          <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
      </li>
      <li class="nav-item {{menuToolbar['adm']['integracionesWoocommerce']}}" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-woocommerce']" data-toggle="tooltip"
           data-placement="auto" title="Integraciones Woocommerce">
          <i data-feather="circle"></i>
          <span class="menu-item text-truncate" data-i18n="List">Integraciones Canales</span></a>
      </li>
      <li class="nav-item {{menuToolbar['adm']['integracionesEnvio']}}" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-envio']" data-toggle="tooltip"
           data-placement="auto" title="Integraciones Envio">
          <i data-feather="circle"></i>
          <span class="menu-item text-truncate" data-i18n="List">Integraciones Envio</span></a>
      </li>

      <li class="navigation-header">Módulos de sistema</li>
      <li class="nav-item" *ngIf="acciones.MDM.LEER">
        <a class="d-flex align-items-center collapsed_menu_item" title="MDM Master Data Managment">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDM Master Data Managment</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['mdm']['param']}}">
            <a class="d-flex align-items-center" [routerLink]="['/mdm/parametrizaciones']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MDM">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="Preview">Prospectos clientes</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdm']['prospectosCli']}}">
                <a class="d-flex align-items-center" [routerLink]="['/mdm/prospectosClientes']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Admin prospectos clientes">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Admin Prospectos Clientes</span></a>
              </li>
              <!-- <li class="nav-item {{menuToolbar['mdm']['addXLSX']}}">
                  <a class="d-flex align-items-center" href="#/mdm/prospectosClientes/addXLSX" data-toggle="tooltip" data-placement="right" title="Carga de prospectos XLSX">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Preview">Carga de prospectos XLSX</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdm']['addCSV']}}">
                  <a class="d-flex align-items-center" href="#/mdm/prospectosClientes/addCSV" data-toggle="tooltip" data-placement="right" title="Carga de prospectos CSV">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Carga de prospectos CSV</span></a>
              </li> -->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Preview">Clientes</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Personas</span></a>
                <ul class="menu-content">
                  <li class="nav-item {{menuToolbar['mdm']['clientesList']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/list']"
                       data-toggle="tooltip" data-placement="auto"
                       title="Administrar de los clientes">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Administración</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['clientesTransac']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/transacciones']"
                       data-toggle="tooltip" data-placement="auto" title="Transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Preview">Transacciones de compra</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['clientesTransacAdd']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/transacciones/add']"
                       data-toggle="tooltip" data-placement="auto"
                       title="Generar transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Edit">Generar transación</span></a>
                  </li>
                  <!-- <li class="nav-item {{menuToolbar['mdm']['clientesTransacLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/personas/transacciones/load" data-toggle="tooltip" data-placement="right" title="Cargar transacciones CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar transacciones</span></a>
                  </li> -->
                  <!-- <li class="nav-item {{menuToolbar['mdm']['clientesLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/personas/load" data-toggle="tooltip" data-placement="right" title="Cargar datos de cliente CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar datos de cliente</span></a>
                  </li> -->
                </ul>
              </li>

              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Negocios</span></a>
                <ul class="menu-content">
                  <li class="nav-item {{menuToolbar['mdm']['negociosList']}}">
                    <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/list"
                       data-toggle="tooltip"
                       data-placement="auto" title="Administrar todos los negocios">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Administración</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosTransac']}}">
                    <a class="d-flex align-items-center"
                       href="#/mdm/clientes/negocios/transacciones/list"
                       data-toggle="tooltip" data-placement="auto" title="Transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Preview">Transacciones de compra</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosTransacAdd']}}">
                    <a class="d-flex align-items-center"
                       href="#/mdm/clientes/negocios/transacciones/add"
                       data-toggle="tooltip" data-placement="auto"
                       title="Generar transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Edit">Generar transación</span></a>
                  </li>
                  <!-- <li class="nav-item {{menuToolbar['mdm']['negociosTransacLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/transacciones/load" data-toggle="tooltip" data-placement="right" title="Cargar transacciones CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar transacciones</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/load" data-toggle="tooltip" data-placement="right" title="Cargar datos de negocios CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar datos de cliente</span></a>
                  </li> -->
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDP.LEER && usuario.usuario.idRol !== 66">
        <a class="d-flex align-items-center" title="MDP Master Data Products">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDP Master Data Products</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['mdp']['param']}}"
              *ngIf="usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
            <a class="d-flex align-items-center" href="#/mdp/parametrizaciones" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones Administracion">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <!--<li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/inventario/list']" data-toggle="tooltip"
               data-placement="auto" title="Super Barato">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Inventario</span>
            </a>
          </li>-->
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol !== 67">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Reportes">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reportes</span></a>
            <ul class="menu-content">
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/inventario/reporte']" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de Inventario Super Barato">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de Inventario</span>
                </a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['abastRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/abastecimiento" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de abastecimiento">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de abastecimiento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/stock" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de stock">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['caduRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/caducidad" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de caducidad de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de caducidad de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['rotaRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/rotacion" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de rotación de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de rotación de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['refilRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/refil" data-toggle="tooltip"
                   data-placement="auto" title="Reporte refil">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de refil</span></a>
              </li>
            </ul>
          </li>

          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 67">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de proveedores">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de proveedores</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" [routerLink]="['mdp/proveedores']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Gestión proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Gestión proveedores</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/buscar-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Buscar Proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Buscar</span></a>
              </li>

            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol !== 60">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de inventario">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de inventario</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Stock Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar Megadescuento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-megabahia"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Stock Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar Megabahía</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-canales"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar inventario por canal">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar inventario por canal</span></a>
              </li>

              <!--<li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/productos" data-toggle="tooltip"
                   data-placement="auto" title="Listar Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Productos</span></a>
              </li>-->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración productos</span></a>
            <ul class="menu-content">

              <li class="nav-item {{menuToolbar['mdp']['cat']}}" *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/categorias" data-toggle="tooltip"
                   data-placement="auto" title="Administrar categorias">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Administración de categorias</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['subCat']}}" *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/subcategorias" data-toggle="tooltip"
                   data-placement="auto" title="Administrar subcategorías">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración subcategorías</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodList']}}">
                <a class="d-flex align-items-center" href="#/mdp/productos" data-toggle="tooltip"
                   data-placement="auto" title="Listado de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Listado de productos</span></a>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/actualizar-inventario"
                   data-toggle="tooltip"
                   data-placement="auto" title="Actualizar inventario y precios">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Actualizar inventario y precios</span></a>
              </li>
              <!--<li class="nav-item {{menuToolbar['mdp']['prodBusq']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/productos/search" data-toggle="tooltip"
                   data-placement="auto" title="Buscar productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Buscar productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockAct']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/productos/actualizarStock" data-toggle="tooltip"
                   data-placement="auto" title="Actualizar Stock de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Actualizar Stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['abastRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/abastecimiento" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de abastecimiento">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de abastecimiento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/stock" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de stock">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['caduRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/caducidad" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de caducidad de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de caducidad de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['rotaRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/rotacion" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de rotación de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de rotación de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['refilRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/refil" data-toggle="tooltip"
                   data-placement="auto" title="Reporte refil">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de refil</span></a>
              </li>-->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de stock virtual">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de stock virtual</span></a>
            <ul class="menu-content">

              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual" data-toggle="tooltip"
                   data-placement="auto" title="Listado de stock virtual">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Listado de stock virtual</span></a>
              </li>

            </ul>
          </li>
          <li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-inventario-catalogo"
               data-toggle="tooltip"
               data-placement="auto" title="Cargar Inventario Catálogo">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Cargar Inventario Catálogo</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDP.LEER">
        <a class="d-flex align-items-center" title="MDRP Motor de recepción de productos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDRP Motor de recepción de productos</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" >
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/recepcion']" data-toggle="tooltip"
               data-placement="auto" title="Recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Recepción de productos</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/confirmacion/recepcion']"
               data-toggle="tooltip"
               data-placement="auto" title="Confirmación recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación recepción de productos</span></a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol !== 66">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/aprobacion']" data-toggle="tooltip"
               data-placement="auto" title="Aprobación recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Aprobación recepción de productos</span></a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol !== 66">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/list']" data-toggle="tooltip"
               data-placement="auto" title="Listado de recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Listado de recepción de productos</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDP.LEER">
        <a class="d-flex align-items-center" title="MDPC Motor de pedidos Canales">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDPC Motor de pedidos Canales</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" >
            <a class="d-flex align-items-center" [routerLink]="['mdpc/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Gestión de Pedidos Canales">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Gestión de Pedidos Canales</span></a>
          </li>
          <li class="nav-item" >
            <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Canales">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos Canales</span></a>
          </li>
          <li class="nav-item" >
            <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/despachados']" data-toggle="tooltip"
               data-placement="auto" title="Confirmación de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación de envío</span></a>
          </li>
          <li class="nav-item" >
            <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/enviados']" data-toggle="tooltip"
               data-placement="auto" title="Pedidos enviados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos enviados</span></a>
          </li>

        </ul>
      </li>
      <li class="ml-2">-------------------------------------</li>
      <li class="nav-item"
          *ngIf="usuario.usuario.idRol === 62 || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 61 || usuario.usuario.idRol === 58 || usuario.usuario.idRol === 54 || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 65">
        <a class="d-flex align-items-center" title="GD Gestión de Drop Shipping">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice" title="GD Gestión de Drop Shipping">GD Gestión de Drop Shipping</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/gd_params']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span>
            </a>
          </li>

          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 64">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Registro de contactos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Registro de contactos</span></a>
            <ul class="menu-content">
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol === 58 || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 54 || usuario.usuario.idRol === 64">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/create']" data-toggle="tooltip"
                   data-placement="auto" title="Ingreso de contactos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Ingresar Contactos</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/list/reporte']" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de lista de contactos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de lista de contactos</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 61 || usuario.usuario.idRol === 65">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Concretar ventas">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Concretar ventas</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/list']" data-toggle="tooltip"
                   data-placement="auto" title="Listar Contactos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Listar Contactos</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/list/reporte/venta']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de contactos por ventas">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de contactos por ventas</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/gd_consulta_productos']" data-toggle="tooltip"
               data-placement="auto" title="Consulta de producto GD">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Consulta de productos</span>
            </a>
          </li>
          <!--<li class="nav-item"
              *ngIf="(usuario.usuario.idRol === 62 && usuario.usuario.canal === 'superbarato.megadescuento.com') || (usuario.usuario.idRol === 62 && usuario.usuario.canal === 'contraentrega.megadescuento.com') || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 63">
            <a class="d-flex align-items-center" [routerLink]="['gd/pedido_woocommerce/crear']" data-toggle="tooltip"
               data-placement="auto" title="Generar Pedido Woocommerce">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar pedido woocommerce</span>
            </a>
          </li>-->
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Asesor/a comercial">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Asesor/a comercial</span></a>
            <ul class="menu-content">
              <li class="nav-item"
              >
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/resgistro']" data-toggle="tooltip"
                   data-placement="auto" title="Registrar asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Registrar asesor@s comerciales</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/list']" data-toggle="tooltip"
                   data-placement="auto" title="Asesor@s comerciales registrada">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Asesor@s comerciales registradas</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/list/confirmados']" data-toggle="tooltip"
                   data-placement="auto" title="Configurar Asesor@s Confirmados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar Asesor@s Confirmados</span>
                </a>
              </li>
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Billetera digital">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Billetera digital</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/billetera/digital/cargar_saldo']"
                       data-placement="auto" title="Cargar saldo billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Cargar saldo billetera digital</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/list/billetera/digital/movimientos']"
                       data-placement="auto" title="Movimientos billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Movimientos billetera digital</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/reporte/pedidos/woocommerce']" data-toggle="tooltip"
                   data-placement="auto" title="Pedidos desde Woocommerce">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos desde Woocommerce</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/reporte/asesor']" data-toggle="tooltip"
                   data-placement="auto" title="Reporte asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte asesor@s comerciales</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MP.LEER">
        <a class="d-flex align-items-center" title="MP Motor de pedidos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MP Motor de pedidos</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['mp']['param']}}" *ngIf="usuario.usuario.idRol !== 51">
            <a class="d-flex align-items-center" href="#/mp/parametrizaciones/list" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MP">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>

          <li class="nav-item {{menuToolbar['mp']['pedidos']}}">
            <a class="d-flex align-items-center" href="#/mp/landing/list" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Landing Vittoria">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Pedidos Landing Vittoria</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-nuevos" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Nuevos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Pedidos Nuevos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos-devueltos']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-devueltos" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Devueltos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Devueltos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos-rechazados']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-rechazados" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Rechazados">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Rechazados</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Pedidos por Canal">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Canal</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Woocomerce autogestión">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Woocomerce autogestión</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/megabahia']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Mega Bahia">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido MegaBahia</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/mayorista']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Mayorista">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Mayorista</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/megadescuento']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Megadescuento">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Megadescuento</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/todomegacentro']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal TodoMegacentro">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido TodoMegacentro</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/tiendamulticompras']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal TiendaMulticompras">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido TiendaMulticompras</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/contraentrega']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Contraentrega">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Contraentrega</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/maxidescuento']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Maxidescuento">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Maxidescuento</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/vittoria']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Vittoria">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Vittoria</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/superbarato']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Superbarato">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Superbarato</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Pedidos entrega local">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Pedidos entrega local</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-entrega-local/list']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-entrega-local/entregados']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos entregados">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos entregados</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item"
          *ngIf="acciones.GDE.LEER || acciones.GDE_EMPACADO.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51">
        <a class="d-flex align-items-center" title="GDE Gestión de entregas">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDE Gestión de entregas</span></a>
        <ul class="menu-content">
          <li *ngIf="acciones.GDE.CREAR" class="nav-item {{menuToolbar['gde']['param']}}">
            <a class="d-flex align-items-center" href="#/gde/parametrizaciones/list"
               title="Parametrizaciones de GDE"
            >
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || acciones.GDE_EMPACADO.CREAR"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceEmpacado']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/empacado" data-toggle="tooltip"
               data-placement="auto" title="Gestión de empacado">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de empacado</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceDespacho']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/despacho" data-toggle="tooltip"
               data-placement="auto" title="Gestión de despacho">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de despacho</span></a>
          </li>
          <li *ngIf="acciones.GDE.ESCRIBIR" class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceEnviado']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/enviado" data-toggle="tooltip"
               data-placement="auto" title="Gestión de enviado">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de enviado</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || usuario.usuario.idRol === 51"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceDevolucion']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/devolucion-paquetes"
               data-toggle="tooltip"
               data-placement="auto" title="Gestión de devolución de paquetes">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Gestión de devolución de paquetes</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR" class="nav-item {{menuToolbar['gde']['reporteVentas']}}">
            <a class="d-flex align-items-center" href="#/gde/reportes"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de entregas">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Reporte de entregas</span></a>
          </li>
          <li *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" href="#/gde/reportes/pedidos"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de pedidos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Reporte de pedidos</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" title="GDB Gestión de bodega">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDB Gestión de bodega</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdb/bodega']" data-toggle="tooltip"
               data-placement="auto" title="Bodega">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Bodega</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdb/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Vittoria">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos a bodega</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="ml-2">-------------------------------------</li>
      <li class="nav-item"
          *ngIf="usuario.usuario.idRol === 58 || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 54">
        <a class="d-flex align-items-center" title="GDP Gestión de pedidos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDP Gestión de pedidos</span></a>
        <ul class="menu-content">

          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['/gdp/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Generador de pedidos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generador de pedidos</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="usuario.usuario.idRol === 59 || usuario.usuario.idRol === 1">
        <a class="d-flex align-items-center" title="GDC Gestión de contacto y venta">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDC Gestión de contacto y venta</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdc/contacto']" data-toggle="tooltip"
               data-placement="auto" title="Contacto">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Despachar contactos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdc/entregados']" data-toggle="tooltip"
               data-placement="auto" title="Despachos entregados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Despachos entregados</span>
            </a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gdc/facturas/cargadas']" data-toggle="tooltip"
               data-placement="auto" title="Confirmación de facturas cargadas">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación de facturas</span>
            </a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gdc/facturas/quejas']" data-toggle="tooltip"
               data-placement="auto" title="Confirmación de quejas">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación de quejas</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.GCN.LEER">
        <a class="d-flex align-items-center" title="GCN Gestión de centro de negocios">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GCN Gestión de centro de negocios</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-vendedor/list" data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas por contacto local">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas por contacto local</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-vendedor-metodo-envio/list"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas por método de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas por método de envío</span>
            </a>
          </li>
          <li
              class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-centro-negocio/list" data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas del centro de negocio por contacto local">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas del centro de negocio por contacto local</span>
            </a>
          </li>
          <li
              class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-centro-negocio-metodo-envio/list"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas del centro de negocio por método de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas del centro de negocio por método de envío</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="usuario.usuario.idRol === 59 || usuario.usuario.idRol === 1">
        <a class="d-flex align-items-center" title="GMB Gestión de Despachos MEGABAHIA">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GMB Gestión de Despachos MEGABAHIA</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gmb/megabahia']" data-toggle="tooltip"
               data-placement="auto" title="GMB Gestión de pedidos MEGABAHIA">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar pedido</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gmb/entregados']" data-toggle="tooltip"
               data-placement="auto" title="Pedidos realizados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos realizados</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="ml-2">-------------------------------------</li>

      <li class="navigation-header">Módulos por afinar</li>
      <li class="nav-item" *ngIf="acciones.MDO.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDO Motor de ofertas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['mdo']['param']}}">
            <a class="d-flex align-items-center" href="#/mdo/parametrizaciones/list" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MDO">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predCross']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/cross" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para crosseling">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para crosseling</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predRefil']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/refil" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para refil">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para refil</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predNueProd']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/nuevos" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para nuevos productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para nuevos productos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['genOferta']}}">
            <a class="d-flex align-items-center" href="#/mdo/oferta/generar" data-toggle="tooltip"
               data-placement="auto" title="Generar oferta para cliente">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar oferta para cliente</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.GDO.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDO Gestión de ofertas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['gdo']['param']}}">
            <a class="d-flex align-items-center" href="#/gdo/parametrizaciones/list"
               title="Parametrizaciones de GDO"
            >
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item {{menuToolbar['gdo']['gestOferta']}}">
            <a class="d-flex align-items-center" href="#/gdo/gestionOferta/list" data-toggle="tooltip"
               data-placement="auto" title="Gestión de la oferta">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de la oferta</span></a>
          </li>
        </ul>
      </li>
      <li class="navigation-header">Módulos de servientrega</li>
      <li class="nav-item" *ngIf="acciones.SERVI.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Servientrega</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['servi']['ciudades']}}">
            <a class="d-flex align-items-center" href="#/servientrega/ciudades" data-toggle="tooltip"
               data-placement="auto" title="Ciudades">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Ciudades</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/crear" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/retorno" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de retorno">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de retorno</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/recaudo" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de recaudo">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de recaudo</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/pdf-a4" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de PDF A4">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de PDF A4</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/digital-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de guías digital PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías digital PDF</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/sticker" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías formato Sticker">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías formato Sticker</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/manifiesto-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de manifiesto PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de manifiesto PDF</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/rotulos-formato-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de Rotulos formato PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de Rotulos formato PDF</span></a>
          </li>
        </ul>
      </li>
      <li class="navigation-header">Facturación Electrónica</li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Canal Vittoria</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-vittoria/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendiente">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendiente</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['facturacion']['externas']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-vittoria/facturadas" data-toggle="tooltip"
               data-placement="auto" title="Factura Electronica">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Factura Electronica</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Canal Externas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-externas/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendiente">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendientes</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['facturacion']['externas']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-externas/facturadas" data-toggle="tooltip"
               data-placement="auto" title="Factura Electronica">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Factura Electronica</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Canal Woocommerce</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-woocommerce/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendientes">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendientes</span>
            </a>
          </li>
          <!--                    <li class="nav-item {{menuToolbar['facturacion']['externas']}}">-->
          <!--                        <a class="d-flex align-items-center" href="#/facturacion/canal-woocommerce/facturadas">-->
          <!--                            <i data-feather="circle"></i>-->
          <!--                            <span class="menu-item text-truncate" data-i18n="List">Factura electronica</span></a>-->
          <!--                    </li>-->
        </ul>
      </li>
      <li class="navigation-header">Reportes</li>
      <li class="nav-item" *ngIf="acciones.REPORTES.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Reportes</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['reportes']['productos']}}">
            <a class="d-flex align-items-center" [routerLink]="['/reportes/productos']" data-toggle="tooltip"
               data-placement="auto" title="Reporte Productos Comprados">
              <i data-feather="list"></i>
              <span class="menu-title text-truncate" data-i18n="List">Reporte Productos Comprados</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['reportes']['clientes']}}">
            <a class="d-flex align-items-center" [routerLink]="['/reportes/clientes']" data-toggle="tooltip"
               data-placement="auto" title="Reporte Clientes Compras">
              <i data-feather="list"></i>
              <span class="menu-title text-truncate" data-i18n="List">Reporte Clientes Compras</span>
            </a>
          </li>
        </ul>
      </li>
      <!--<li class="navigation-header">Todomegacentro</li>
      <li class="nav-item" *ngIf="acciones.TODOMEGA.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Todo mega centro</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['todomegacentro']['inicio']}}">
            <a class="d-flex align-items-center" href="#/todomegacentro/inicio" data-toggle="tooltip"
               data-placement="auto" title="Inicio">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Inicio</span></a>
          </li>
        </ul>
      </li>-->
    </ul>
  </div>
</div>
